import { createAction } from '@reduxjs/toolkit'

const APP_ACTION = "App/";

export const SetSidebarState = createAction(`${APP_ACTION}SetSidebarState` );
export const SetArea = createAction(`${APP_ACTION}SetArea`);
